const CAROUSEL_ITEMS = [
  {
    title: '2024年度十佳国产剧盘点',
    desc: '从开年爆款到年末黑马，回顾这一年最值得追的国产好剧，你看过几部？',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20scene%20showing%20a%20collection%20of%20Chinese%20drama%20posters%20arranged%20artistically%20on%20a%20dark%20wall%2C%20warm%20spotlight%20illumination%2C%20golden%20and%20red%20accent%20colors%2C%20film%20festival%20atmosphere%2C%20elegant%20exhibition%20display&width=1200&height=600&seq=carousel-01-2026&orientation=landscape',
    tag: '年度盘点',
  },
  {
    title: '暑期档必看：热门综艺指南',
    desc: '炎炎夏日宅家必备，盘点今夏最火爆的综艺节目，搞笑解压一网打尽',
    image: 'https://readdy.ai/api/search-image?query=A%20bright%20summery%20TV%20studio%20scene%20with%20colorful%20stage%20decorations%2C%20vibrant%20lighting%2C%20variety%20show%20set%20design%2C%20energetic%20entertainment%20vibe%2C%20warm%20golden%20hour%20backlight%2C%20fun%20and%20lively%20atmosphere&width=1200&height=600&seq=carousel-02-2026&orientation=landscape',
    tag: '综艺专题',
  },
  {
    title: '高分韩剧推荐：部部经典',
    desc: '豆瓣8.5分以上的韩剧精选，从悬疑犯罪到浪漫爱情，每部都值得二刷',
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20evening%20scene%20with%20a%20large%20screen%20displaying%20Korean%20drama%20scenes%2C%20warm%20ambient%20lighting%2C%20comfortable%20living%20room%20setting%2C%20soft%20throws%20and%20cushions%2C%20cinematic%20mood%20lighting%2C%20relaxing%20atmosphere&width=1200&height=600&seq=carousel-03-2026&orientation=landscape',
    tag: '海外剧场',
  },
  {
    title: '动漫新番速递：秋季档前瞻',
    desc: '十月新番强势来袭，国漫日漫齐上阵，为你精选最值得追的动画作品',
    image: 'https://readdy.ai/api/search-image?query=A%20creative%20animation%20style%20scene%20with%20vibrant%20colorful%20characters%20and%20dynamic%20compositions%2C%20anime%20art%20style%2C%20warm%20autumn%20color%20palette%2C%20energetic%20action%20poses%2C%20cinematic%20framing%2C%20soft%20bokeh%20background&width=1200&height=600&seq=carousel-04-2026&orientation=landscape',
    tag: '动漫推荐',
  },
  {
    title: '经典港片重温：黄金年代记忆',
    desc: '回到香港电影的璀璨时代，重温那些年我们追过的经典港片和传奇巨星',
    image: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20Hong%20Kong%20street%20scene%20at%20night%20with%20neon%20lights%2C%20old%20cinema%20posters%20on%20walls%2C%20warm%20vintage%20color%20tones%2C%20classic%20film%20atmosphere%2C%20rainy%20pavement%20reflecting%20colorful%20lights%2C%20cinematic%20photography&width=1200&height=600&seq=carousel-05-2026&orientation=landscape',
    tag: '经典回顾',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            <i className="ri-focus-2-line mr-1"></i>焦点专题
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            精选影视专题推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            编辑团队精心策划的影视专题，带你发现更多好内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {CAROUSEL_ITEMS.map((item, i) => (
            <div
              key={i}
              className={`group relative rounded-2xl overflow-hidden border border-background-200/60 cursor-pointer ${i < 2 ? 'lg:col-span-3 md:col-span-2' : ''}`}
            >
              <div className={`relative ${i < 2 ? 'h-48 md:h-64' : 'h-48 md:h-56'}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-accent-500 text-white text-xs font-semibold rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <h3 className="font-heading text-lg md:text-xl font-bold text-white mb-2 group-hover:text-accent-300 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-white/80 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}